import { render, staticRenderFns } from "./RestoreAlarmType.vue?vue&type=template&id=5740a234"
import script from "./RestoreAlarmType.vue?vue&type=script&lang=js"
export * from "./RestoreAlarmType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports